import ApiClient from '@/services/apiClient';

export default class Delay {
    value;
    unit;   //"s", "m", "h"

    constructor(value = 0, unit = 's') {
      this.value = value;
      this.unit = unit;
    }
  
    static constructFromObject(data, obj) {
      obj = obj || new Delay();
      if(data) {
          obj.value = ApiClient.convertToType(data['value'], 'Integer');
          obj.unit = ApiClient.convertToType(data['unit'], 'String');
      }
      return obj;
    }
}
  